import { Link } from 'react-router-dom'

import { Button } from '@/components/ui/button'
import { messages } from '@/lib/messages'

export function NotFoundPage() {
  return (
    <div className="flex flex-1 flex-col items-center justify-center gap-3 p-10 text-center">
      <p className="text-lg font-semibold">{messages.states.notFoundTitle}</p>
      <p className="text-muted-foreground text-sm">{messages.states.notFoundHint}</p>
      <Button nativeButton={false} render={<Link to="/" />} size="sm">
        {messages.states.goHome}
      </Button>
    </div>
  )
}
